import { render, staticRenderFns } from "./legal-foot-note.vue?vue&type=template&id=7d10b78c&"
import script from "./legal-foot-note.vue?vue&type=script&lang=js&"
export * from "./legal-foot-note.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports